export const CUSTOMER_FORM_ID = 'customer-form';
export const CONTAINER_WIDTH = 1050;
export const UNIMPLEMENTED_TEXT = '!!!!! PENDING COPY IMPLEMENTATION !!!!!';
export const SWEDISH_SSN_PLACEHOLDER = 'ÅÅMMDD-XXXX';
export const DEFAULT_ERROR_MESSAGE = 'Något gick fel. Vänligen kontakta support.';
export const NEW_BANK = 'annan';
export const NEW_BANK_NAME = 'Annan/Okänd/Ingen';
export const BANKING_INFO_MESSAGE = 'Ange bankens namn och adress med kommatecknen mellan varje del. ex.(namn, adress, postnummer stad)';
